<template>
    <div class="p-3">
        <!-- Begin Page Content -->
        <div class="book-appointment">
            <div class="mainTitle mb-2 d-flex align-items-center justify-content-between p-2 bg-white border-radius-5">
                <div class="d-flex align-items-center">
                    <!-- <div class="customDropDownBtn position-relative">
                        <a @click.prevent="setToggle = !setToggle; setStatus = false; setStatusfilter = false" class="addBtn themecolor bg-white d-flex align-items-center medium filter-dropdown" href="javascript:void(0)">
                           {{(list_type != '') ?  $env_var.patientListfilter[list_type] :  'Select Filter'}}
                            <feather class="ml-2" type="chevron-down"></feather> 
                        </a>
                        <ul class="dropdown_menu dropdown_menu--animated dropdown_menu-6" :class="setToggle?'show':''">
                            <li  v-for="value,key in $env_var.patientListfilter" :for="'date_'+key">
                                <label class="checkbox"> {{value}}
                                    <input type="radio" :id="'date_'+key"  :value="key" name="date" v-model="list_type" @change="page = 1; select_date = '' ; showListItem = -1; listing()">
                                    <span class="checkmark"></span>
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div class="customDropDownBtn position-relative ml-2">
                        <a @click.prevent="setStatus = !setStatus; setToggle = false; setStatusfilter = false" class="addBtn themecolor bg-white d-flex align-items-center medium filter-dropdown" href="javascript:void(0)">
                             {{(today_filter != '') ?  today_filter :  'Check Status'}} <feather class="ml-2" type="chevron-down"></feather> </a>
                        <ul class="dropdown_menu dropdown_menu--animated dropdown_menu-6" :class="setStatus?'show':''">
                            <li v-for="value,key in $env_var.appointmentTodayFilters" :for="'today_'+key" :class="[{'checked':today_filter == value}]">
                                <label class="checkbox"> {{value}}
                                    <input type="radio" :id="'today_'+key" :value="value" name="today_check" v-model="today_filter" @change="page = 1; select_date = '' ; showListItem = -1; listing()">
                                    <span class="checkmark"></span>
                                </label>
                            </li>
                        </ul>
                    </div>  -->

                    <div class="customDropDownBtn position-relative ml-2">
                        <a @click.prevent="setStatusfilter = !setStatusfilter; setToggle = false; setStatus = false" class="addBtn themecolor bg-white d-flex align-items-center medium filter-dropdown" href="javascript:void(0)">
                             {{(status_filter != '') ?  $env_var.appointmentStatusFilters[status_filter] :  'Select Status'}} <feather class="ml-2" type="chevron-down"></feather> </a>
                        <ul class="dropdown_menu dropdown_menu--animated dropdown_menu-6" :class="setStatusfilter?'show':''">
                            <li v-for="value,key in $env_var.appointmentStatusFilters" :for="'today_'+key">
                                <label class="checkbox"> {{value}}
                                    <input type="radio" :id="'today_'+key" :value="key" name="today" v-model="status_filter" @change="page = 1; select_date = '' ; showListItem = -1; listing()">
                                    <span class="checkmark"></span>
                                </label>
                            </li>
                        </ul>
                    </div>
                    <!-- <div class="rightblock d-flex align-items-center ml-2" :class="mobToggle?'showFilter':''">
                        <h6 class="d-lg-none mb-5 themecolor border-bottom pb-2 uppercase">Search Filter</h6>
                        
                        <div class="filterButton form-group p-0 d-flex align-items-center">
                            <date-picker class="form-control" :lang="lang" v-model="select_date" name="appointment date" placeholder="Select appointment date" @input="list_type = '';listing()"></date-picker>
                            <span class="searchico red pointer" v-if="select_date"><feather type="x" @click="select_date = '' ; listing()"></feather></span>
                            
                        </div>
                    </div> -->
                </div>
                <!-- <div class="rightblock d-flex align-items-center justify-content-end">
                    <div v-on:keyup.enter="listing()" class="filterButton form-group inSearch m-0 p-0">
                        <input type="text" class="form-control" placeholder="Search Here" v-model="search">
                        <a href="javascript:void(0)" @click="listing()" class="searchico"><feather type="search" class="text-right"></feather></a>
                    </div>
                    <a href="javascript:void(0)" @click.prevent="mobToggle = !mobToggle" class="d-lg-none inFilter"><feather type="filter"></feather></a>
                </div> -->
                <!-- <div class="rightblock d-flex align-items-center justify-content-end" v-else>
                    <div class="ltr mr-2" v-if="pageName == 'dashboard'">
                        <a href="javascript:void(0)" class="addBtn themecolor bg-white d-flex align-items-center medium" @click="redirectToPage('add','')">
                            <span class="plusCircle mb-0 mr-1"><feather type="plus"></feather></span>Add
                        </a>
                    </div>
                    <router-link to="/apponitment-list" class="themecolor bg-white d-flex align-items-center medium">
                        See All Appoitments
                    </router-link>
                </div> -->
            </div> 
            <div class="listData my-3">
                <div class="card-body h-100 p-0">
                    <!-- Tab panes -->
                    <div class="table-reponsive">
                      
                        <table class="table separateTable">
                            <thead>
                                <tr>
                                  <th>Doctor Name</th>
                                  <th>MO Name</th>
                                  <th>Care Coordinator</th>
                                  <th>Appointment Date</th>
                                  <th>Time</th>
                                  <th>Type</th>
                                  <th>Help With</th>
                                  <th>Status</th>
                                  <th>Created</th>
                                  <th>Action</th>

                                </tr>
                            </thead>
                            <tbody v-if="pageLoader">
                                <table-loader :colspan="colspan"></table-loader>
                            </tbody>
                            <tbody v-else-if="!pageLoader && !appointmentList.totalRecords">
                                <no-record :type="'table'" :colspan="colspan"></no-record>
                            </tbody>
                            <tbody v-else-if="!pageLoader && appointmentList.totalRecords && appointmentList.totalRecords > 0">
                                <tr v-for="list in appointmentList.records">
                                    <td>{{list.doctorName || '-'}}</td>
                                    <td>{{list.moHospital || '-'}}</td>
                                    <td>{{list.careCordinator || '-'}}</td>
                                    <td>
                                       <p class="d-inline-flex align-items-center" v-if="list.appointment_date != '' && list.appointment_date != null && list.appointment_date != '0000-00-00T00:00:00'"><feather class="mr-1" size="15px" type="calendar"></feather>{{formatDate(list.appointment_date)}}</p>
                                       <p class="d-inline-flex align-items-center" v-else>-</p>
                                    </td>
                                    <td>
                                        <span class="f-12 d-flex align-items-center" v-if="list.start_time != '' && list.start_time != null && list.end_time != '' && list.end_time != null">
                                            <feather type="calendar"></feather> {{formatTime(list.start_time,list.end_time)}}    
                                        </span>
                                        <span class="f-12 d-flex align-items-center" v-else>-</span>
                                    </td>
                                    <td>{{list.appoint_type?$env_var.appointmentTypeJson[list.appoint_type]:'-'}}</td>
                                    <td>{{GetData(list.enquiry) || '-'}}</td>
                                    <td>
                                        <span class="timeInc statusPad bgcolor1"  v-if="list.appointStatus != null && $env_var.appointmentChangeStatusJson[list.appointStatus]">
                                            {{$env_var.appointmentChangeStatusJson[list.appointStatus]}}
                                        </span>
                                        <span class="timeInc underline p-0 color10" v-else>-</span>
                                    </td>
                                    <td>
                                       <p class="d-inline-flex align-items-center" v-if="list.appointment_date != '' && list.appointment_date != null && list.appointment_date != '0000-00-00T00:00:00'"><feather class="mr-1" size="15px" type="calendar"></feather>{{formatDate(list.appointCreated)}}</p>
                                       <p class="d-inline-flex align-items-center" v-else>-</p>
                                    </td>
                                    <td>
                                        <div class="btnEdit">
                                            <router-link :to="{ 'path':'/appointment-detail' , query:{'id': list.id} }"><feather type="eye"></feather></router-link>
                                        </div>
                                    </td>
                              </tr>
                            </tbody>
                        </table>
                    </div>
                    <app-pagination :totalRecords="appointmentList.totalRecords" :limit="pageLimit" :pageNo="page" v-if="appointmentList.totalRecords && appointmentList.totalRecords > pageLimit"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'Appointment-List',
        data() {
            return {
                pageLoader: false,
                pageLimit : 10,
                page : 1,
                colspan: 10,
                lang: 'en',
                setToggle : false,
                mobToggle:false,
                search : '',
                list_type :'1',
                today_filter :'All',
                status_filter : 1,
                setStatusfilter : false,
                setStatus : false,
                select_date :'',
                disabledDates: {
                  to: new Date(Date.now() - 8640000)
                },

            }
        },
        methods: {
            GetData(getdata){
                try{
                    let data = JSON.parse(getdata)
                    if(Object.keys(data).length > 0){
                        return Object.values(data).map(val => val).join(',')
                    }else{
                        return '-'
                    }
                }catch(e){
                    return getdata
                }

            },
            listing() {
                /*"page"  : this.page,
                        "limit" : this.pageLimit,
                        "search_by" : (this.search != '') ? this.search.trim() : '',
                        "listBy": this.$env_var.patientListfilter[this.list_type],*/
                let input_json = {
                    'globalParams' : {
                        "search_by_name": '', 
                        "page":this.page, 
                        "limit": this.pageLimit, 
                        //"role_id" : parseInt(this.roleTabId),
                        "listBy": this.$env_var.patientListfilter[this.list_type],
                        //"assigned_to" : (this.roleTabId == 6 || this.roleTabId == 7) ? this.filter_admin : '',
                        "app_status" : parseInt(this.status_filter)
                    },
                    'localParams' :{'parameter' : this}
                }
                this._runGetAppointmentList(input_json)
            },
            formatTime(startTime,endTime){
                let start = '',startSplit = '', end = '', endSplit = ''
                start =  moment(startTime ,["h:mm:ss A"])
                startSplit =  moment(start).format("HH:mm")
                end =  moment(endTime ,["h:mm:ss A"])
                endSplit =  moment(end).format("HH:mm")
                return startSplit+'-'+endSplit
            },
        },
        mounted() {
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.filter-dropdown').length){
                    _that.setToggle = false
                    _that.setStatus = false
                    _that.setStatusfilter = false
                }
            });
            // scrool table
            // $( window ).resize(function() {
            //     var elem = $('#tableList');
            //     if(elem.scrollLeft() == 0){
            //         _that.tableScroll =false
            //     }else { _that.tableScroll = true }
            // })
            // if($('#tableList')[0].scrollWidth-2 <= $('#tableList').outerWidth()){
            //     _that.tableScroll =false
            // }
            // $('#tableList').on('scroll', (e)=>{
            //     var elem = $(e.currentTarget);
            //     if(elem.scrollLeft() == 0){
            //         _that.tableScroll =false
            //     }else { _that.tableScroll = true }
            // });
        },
        created(){
            this.listing()
            this.pageName('Appointment List')
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/website/appointments/appointment-list.vue